import { IAutomationObject } from "../../../types";

export interface IControlledCoolingOutletPumpControl extends IAutomationObject {
    sDewPointMonitor: boolean;
    request: boolean;
    release: boolean;
}


export const schema = 'AutomationApps.Logics.Coolings.ControlledCoolingOutletPumpControl';


